<template>
  <div id="app">
    <router-view v-if="!$route.query.keepAlive&&!route.includes($route.name)" :key="$route.fullPath" />
    <keep-alive>
      <router-view v-if="$route.query.keepAlive||route.includes($route.name)" />
      <!--这里是会被缓存的组件-->
    </keep-alive>
  </div>

</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      route: ['map']
    }
  }
}
</script>

<style lang="less">
/* 需替换。现在是ifont icon (login, registor, keyBoard) */
@import "./assets/font-icon/iconfont.css";
@import "./assets/css/common.less";
html,body{
  margin: 0;
  padding: 0;
  font-family: Arial, Helvetica, sans-serif;

  //错时管理界面需要修改2个dialog确认框样式  写在这里（原因：提示框css层级高不在当前页面,在body下）
  .manage-diffTimeBag{
    .weui-dialog{
      border-radius: 10px;
      //标题样式
      .weui-dialog__hd{
        text-align: left;
      }
      //content样式
      .weui-dialog__bd{
        padding: 0 2em 0.8em;
        text-align: left;
        font-size: 12px;
        line-height: 24px;
        color: #333;
        letter-spacing: 1px;
      }
      //btn样式
      .weui-dialog__ft{
        font-size: 16px;
      }
    }
  }
  .manage-diffTimeBook{
    .weui-dialog {
      border-radius: 10px;
      //btn样式
      .weui-dialog__ft{
        font-size: 16px;
      }
    }
  }
}
/* placeholder 颜色设置 */
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: #c5c5c5;
}
::-moz-placeholder { /* Firefox 19+ */
  color: #c5c5c5;
}
:-ms-input-placeholder { /* IE 10+ */
  color: #c5c5c5;
}
:-moz-placeholder { /* Firefox 18- */
  color: #c5c5c5;
}
/* weui 确认颜色统一为平台蓝 */
.weui-dialog__btn_primary {
    color:#3880FF;
}

// 富文本查看表格样式(对查看的时候需要自己手动加table/td/th的样式,不然就只有内容没有线)
 .notice-wang-editor {
   table {
     border: none;
     border-collapse: collapse;
   }
   table td,
   table th{
     border: 1px solid #ccc;
     padding: 3px 5px;
     min-width: 50px;
     height: 20px;
   }
   table th {
     border-right: 1px solid #ccc;
     border-bottom: 2px solid #ccc;
     text-align: center;
     background-color: #f1f1f1;
   }
   blockquote{
     display: block;
     border-left: 8px solid #d0e5f2;
     padding: 5px 10px;
     margin: 10px 0;
     line-height: 1.4;
     font-size: 100%;
     background-color: #f1f1f1;
   }
   code{
    display: inline-block;
    *display: inline;
    *zoom: 1;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
   }
   pre code {
     display: block;
   }
   ul, ol{
     margin: 10px 0 10px 20px;
   }
   pre {
    border: 1px solid #ccc;
    background-color: #f8f8f8;
    padding: 10px;
    margin: 5px 0px;
    font-size: 0.8em;
    border-radius: 3px;
   }
   ul li {
      list-style-type: disc;    // 解决序列li前面的.不展示问题
   }
    ol li {
      list-style-type: decimal;   // 解决序列li前面的数字不展示问题
   }
 }
 // 用flex实现水平垂直居中 用于tag btn 定高的容器
 .flex_center {
    display: flex;
    align-items: center;
    justify-content: center;
 }

</style>
